import { render } from "./BoxContent.vue?vue&type=template&id=3ccdeb56"
import script from "./BoxContent.vue?vue&type=script&lang=js"
export * from "./BoxContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__